var THEME_CONFIG = {
    light: {
        'login-background-color': 'var(--secondary-color)',
        'input-inside-color': 'rgba(0, 0, 0, 0.08)'
    },
    dark: {
        'login-background-color': "var(--secondary-color)",
        'input-inside-color': 'rgba(0, 0, 0, 0.5)'
    },
    'two-tone': {
        'login-background-color': "var(--secondary-color)",
        'input-inside-color': 'rgba(255, 255, 255, 0.5)'
    },
    inverted: {
        'login-background-color': "var(--secondary-color)",
        'input-inside-color': 'rgba(255, 255, 255, 0.5)'
    }
};
var createThemeCSSVariables = function (themeName) {
    var root = document.documentElement;
    var config = THEME_CONFIG[themeName];
    if (config) {
        root === null || root === void 0 ? void 0 : root.style.setProperty('--login-background-color', config['login-background-color']);
        root === null || root === void 0 ? void 0 : root.style.setProperty('--input-inside-color', config['input-inside-color']);
    }
};

export { THEME_CONFIG, createThemeCSSVariables };
//# sourceMappingURL=ThemeConfig.js.map
